var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.542,
    height: 9.542,
    viewBox: "0 0 9.542 9.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filter_icon",
    "data-name": "Filter Icon",
    d: "M7.342,1.928c-2.635,0-4.771.668-4.771,1.491v.895L6.149,7.892v2.982c0,.329.534.6,1.193.6s1.193-.267,1.193-.6V7.892l3.578-3.578V3.419C12.113,2.6,9.977,1.928,7.342,1.928ZM3.45,3.222a4.058,4.058,0,0,1,.906-.349,11.762,11.762,0,0,1,2.985-.348,11.762,11.762,0,0,1,2.985.348,4.059,4.059,0,0,1,.906.349,1.037,1.037,0,0,1,.264.2,1.038,1.038,0,0,1-.264.2,4.059,4.059,0,0,1-.906.349,11.762,11.762,0,0,1-2.985.348,11.762,11.762,0,0,1-2.985-.348,4.058,4.058,0,0,1-.906-.349,1.038,1.038,0,0,1-.264-.2A1.038,1.038,0,0,1,3.45,3.222Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.25d3320e39903ec2e83146580b337e56.svg";
export { ForwardRef as ReactComponent };